const myomePdf = (filename: string): string => `https://myome.com/pdfs/${encodeURIComponent(filename)}`;

const resource = (title: string, filename: string) => ({
  title,
  url: myomePdf(filename),
});

const CARDIOMETABOLIC_IR_TECHNICAL = resource(
  'Atlas Cardiometabolic Integrated Risk Technical One Pager',
  'M-132_Atlas Cardiometabolic Integrated Risk_Technical One Pager_v1.pdf',
);

const CANCER_IR_TECHNICAL = resource(
  'Atlas Cancer Integrated Risk Technical One Pager',
  'M-126_Atlas Cancer Integrated Risk_Technical One Pager_v1.pdf',
);

const CARDIOMETABOLIC_IR_SAMPLES = [
  resource(
    'Atlas Cardiometabolic Integrated Risk Product One Pager',
    'M-134_Atlas Cardiometabolic Integrated Risk_Product One Pager_v1.pdf',
  ),
  resource(
    'Atlas Cardiometabolic Integrated Risk Provider Understanding Results',
    'M-144_Atlas Cardiometabolic Integrated Risk_Provider Understanding Results_v1.pdf',
  ),
  CARDIOMETABOLIC_IR_TECHNICAL,
  CARDIOMETABOLIC_IR_TECHNICAL,
];

const CANCER_IR_SAMPLES = [
  resource(
    'Atlas Cancer Integrated Risk Product One Pager',
    'M-127_Atlas Cancer Integrated Risk_Product One Pager_v1.pdf',
  ),
  resource(
    'Atlas Cancer Integrated Risk Provider Understanding Results',
    'M-146_Atlas Cancer Integrated Risk_Provider Understanding Results_v1.pdf',
  ),
  CANCER_IR_TECHNICAL,
  CANCER_IR_TECHNICAL,
];

export const SINGLE_GENE_SAMPLES = [
  resource('Atlas Curated Screen Product One Pager', 'M-129_Atlas Curated Screen_Product One Pager_v1.pdf'),
  resource(
    'Atlas Curated Screen Patient Understanding Results',
    'M-142_Atlas Curated Screen_Patient Understanding Results_v1.pdf',
  ),
  resource(
    'Atlas Curated Screen PLUS Technical One Pager - 151 Genes',
    'M-131_Atlas Curated Screen PLUS_Technical One Pager_v1.pdf',
  ),
  resource(
    'Atlas Curated Screen SELECT Technical One Pager - 84 Genes',
    'M-130_Atlas Curated Screen SELECT_Technical One Pager_v1.pdf',
  ),
  {
    // Obsolete 81-gene panel: no Atlas replacement.
    title: 'Single-Gene Risk Technical One Pager - 81 Genes',
    url: 'https://myome.com/pdfs/MYO-24-019-PHR-v2-Technical-One-Pager_Final_DIGITAL_Proactive-Health-Plus_Technical-One-Pager_81-Genes.pdf',
  },
];

export const CAD_SAMPLES = CARDIOMETABOLIC_IR_SAMPLES;
export const TYPE_2_DIABETES_IPRS_SAMPLES = CARDIOMETABOLIC_IR_SAMPLES;
export const BREAST_CANCER_IPRS_SAMPLES = CANCER_IR_SAMPLES;
export const PROSTATE_CANCER_IPRS_SAMPLES = CANCER_IR_SAMPLES;

export const BASELINE_CARDIOMETABOLIC_SAMPLE = resource(
  'Atlas Cardiometabolic Baseline Risk Patient Understanding Results',
  'M-145_Atlas Cardiometabolic Baseline Risk_Patient Understanding Results_v1.pdf',
);

export const BASELINE_CANCER_SAMPLE = resource(
  'Atlas Cancer Baseline Risk Patient Understanding Results',
  'M-147_Atlas Cancer Baseline Risk_Patient Understanding Results_v1.pdf',
);

export const APOE_PATIENT_UNDERSTANDING = resource(
  'Understanding Your APOE Add-On Results',
  'm-157-atlas-apoe-patient-understanding-results-guide-v1.pdf',
);

export const PGX_SAMPLES = [
  resource('Atlas Medication Response Product One Pager', 'M-064_Atlas Medication Response_Product One Pager_v3.pdf'),
  resource(
    'Atlas Medication Response Patient Understanding Results',
    'M-140_Atlas Medication Response_Patient Understanding Results_v1.pdf',
  ),
  resource(
    'Atlas Medication Response SELECT Technical One Pager',
    'M-135_Atlas Medication Response SELECT_Technical One Pager_v1.pdf',
  ),
  resource(
    'Atlas Medication Response PLUS Technical One Pager',
    'M-136_Atlas Medication Response PLUS_Technical One Pager_v1.pdf',
  ),
];
